module.exports = "<div class=\"editorUi-row\">\n  <global-tabs :props=\"$props\" :activeOverride=\"override\" :tabs=\"tabs\" :border=\"'#1a1b20'\"></global-tabs>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/editor/page/top-control-bar/dynamic-data/store/template.html
// module id = mXL8
// module chunks = 0